// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FSRk","index":"styles_index__1CqAw"};